/**
 * Comment Validation
 * Handles all form validation and input checking for comments
 */

import { CommonUtils } from "../util/common-utils";
import { notifier } from "../core/notifier/notifier";
import { commentForm } from "./comment-form";

class CommentValidationUtils {
    public static validateCommentForm(form: HTMLFormElement): boolean {
        const textarea = commentForm.getCommentContentTextarea(form);
        const content = textarea?.value?.trim();

        if (!content) {
            notifier.warn("comments_enter_content", {});
            textarea?.focus();
            return false;
        }

        if (content.length > 1000) {
            notifier.warn("comments_content_too_long", {});
            textarea?.focus();
            return false;
        }

        return true;
    }

    public static validateContentLength(content: string, maxLength = 1000): boolean {
        return content && content.length > 0 && content.length <= maxLength;
    }

    public static sanitizeContent(content: string): string {
        return CommonUtils.escapeHtml(content);
    }
}

export { CommentValidationUtils };
